
import kebabCase from 'lodash.kebabcase';
import { Component, defineComponent } from 'vue';
import RequireContext = __WebpackModuleApi.RequireContext;

const icons: { [key: string]: Component } = {};

const requireComponents = require.context('./icons/', false, /[\w]+Icon\.vue$/);

requireComponents.keys().forEach((fileName) => {
  const iconName = kebabCase(fileName.replace(/^\.\/(.+)Icon\.vue/, '$1'));
  const componentConfig = requireComponents(fileName) as RequireContext;
  icons[iconName] =
    (componentConfig as unknown as { default: Component }).default ||
    componentConfig;
});

export default defineComponent({
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator(value: string) {
        return Object.prototype.hasOwnProperty.call(icons, value);
      },
    },
    width: {
      type: Number,
      required: false,
      default: 25,
      validator(value) {
        return Number.isInteger(value);
      },
    },
    height: {
      type: Number,
      required: false,
      default: 25,
      validator(value) {
        return Number.isInteger(value);
      },
    },
    strokeWidth: {
      type: Number,
      required: false,
      default: 1,
      validator(value) {
        return Number.isInteger(value);
      },
    },
  },
  computed: {
    iconComponent(): Component {
      return icons[this.name];
    },
    getStyle(): {
      height: string;
      width: string;
      'stroke-width': string;
    } {
      return {
        height: `${this.height || '20'}px`,
        width: `${this.width || '20'}px`,
        'stroke-width': `${this.strokeWidth || '1'}px`,
      };
    },
  },
  mounted() {
    this.$emit('mounted');
  },
});
